"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Nearby = void 0;
const react_1 = __importStar(require("react"));
const matchesMediaSwitcher_1 = require("@geome/react-next/lib/util/matchesMediaSwitcher");
const detailedLinkCard_1 = require("@geome/react-components-next/lib/components/detailedLinkCard");
const itemCarousel_1 = require("@geome/react-components-next/lib/components/itemCarousel");
const openNow_1 = require("@geome/react-components-next/lib/components/openNow");
const useStaticMapUrl_1 = require("@geome/react-components-next/lib/components/staticMap/hooks/useStaticMapUrl");
const react_next_1 = require("@geome/react-next");
const Nearby = ({ nearby }) => {
    const locations = (0, react_1.useMemo)(() => nearby.map((n) => (react_1.default.createElement(NearbyLocation, { key: n.id, location: n, params: { template: n.static_map_url, locale: "en_GB" } }))), [nearby]);
    return (react_1.default.createElement(matchesMediaSwitcher_1.MatchesMediaSwitcher, { mediaQueries: ["(max-width: 720px)", "(max-width: 1023px)", ""] },
        react_1.default.createElement(itemCarousel_1.ItemCarousel, { sectionName: "nearby", configPath: "station_page.", perPage: 1, renderBefore: () => react_1.default.createElement("div", { className: "nearby__backdrop" }) }, locations),
        react_1.default.createElement(itemCarousel_1.ItemCarousel, { sectionName: "nearby", configPath: "station_page.", perPage: 2, renderBefore: () => react_1.default.createElement("div", { className: "nearby__backdrop" }) }, locations),
        react_1.default.createElement(itemCarousel_1.ItemCarousel, { sectionName: "nearby", configPath: "station_page.", perPage: 4, renderBefore: () => react_1.default.createElement("div", { className: "nearby__backdrop" }) }, locations)));
};
exports.Nearby = Nearby;
const WIDTH = 300;
const HEIGHT = 175;
const NearbyLocation = ({ params, location }) => {
    var _a, _b;
    const darkMode = (0, react_next_1.useMatchMedia)("(prefers-color-scheme: dark)");
    const imageSrc = (0, useStaticMapUrl_1.useStaticMapUrl)(Object.assign(Object.assign({}, params), { id: location.id, width: WIDTH, height: HEIGHT, zoom: 15, mode: darkMode ? "dark" : "light" }));
    return (react_1.default.createElement(detailedLinkCard_1.DetailedLinkCard, { imageSrc: imageSrc, href: (_a = location.href) !== null && _a !== void 0 ? _a : "", imgHeight: HEIGHT, imgWidth: WIDTH, target: "_self" },
        react_1.default.createElement("div", { className: "detailed-link-card__text nearby__content" },
            react_1.default.createElement("h3", { className: "detailed-link-card__title" }, location.name),
            react_1.default.createElement("p", { className: "detailed-link-card__body" }, location.formatted_address),
            react_1.default.createElement(openNow_1.OpenNow, { openStatus: location.open_status, tzOffset: (_b = location.tz_offset) !== null && _b !== void 0 ? _b : undefined, nextOpenStatusChange: location.next_open_status_change, configPath: "station_page." }))));
};
